import React from "react";
import { TableRow } from "@mui/material";
import { StyledTableCell } from "../../../../../../shared/components/CustomTable/Styled";
import { StyledNavLink } from "../../../../../../shared/styled/TableStyles";
import Status from "../../../../../../shared/components/Status";
import { formatCurrency } from "../../../../../../utils/format";

interface TopCustomer {
    id: string;
    rank: number;
    total_orders_price: number;
    customer_name: string;
    percentage_of_revenue: number;
}

const getColorTheme = (rank: number) => {
    switch (rank) {
        case 1:
            return "INFO";
        case 2:
            return "SUCCESS";
        case 3:
            return "PENDING";
        case 4:
            return "WARNING";
        case 5:
        default:
            return "FAIL";
    }
};

export const TopCustomerRow = ({ item }: { item: TopCustomer }) => {
    return (
        <TableRow>
            <StyledTableCell align="left">{item.rank}</StyledTableCell>
            <StyledTableCell align="left">{item.customer_name}</StyledTableCell>
            <StyledTableCell align="left">
                {formatCurrency(item.total_orders_price)}
            </StyledTableCell>
            <StyledTableCell align="left">
                <Status
                    text={item.percentage_of_revenue.toString()}
                    colorTheme={getColorTheme(item.rank)}
                    width="28px"
                />
            </StyledTableCell>
        </TableRow>
    );
};
